module.exports = __webpack_public_path__ + "img/ring_g_l_0_0@2x.6f799348.png";